__turbopack_context__.v({
  "wrapper": "SimpleHeaderBar-module-scss-module__eBehUa__wrapper",
});
